import type { InferOutput } from "valibot";

declare global { const shop_options: ShopOptions; }

export const shopFilterSchema = v.intersect([
  v.object({
    name: v.string(),
    label: v.string(),
  }),
  v.variant("component", [
    v.object({
      component: v.literal("FilterCheckbox"),
      attrs: v.object({
        options: v.array(v.object({
          value: v.string(),
          label: v.optional(v.string()),
          count: v.optional(v.number()),
        })),
      }),
      default_value: v.array(v.string()),
    }),
    v.object({
      component: v.literal("FilterRange"),
      attrs: v.object({
        min: v.number(),
        max: v.number(),
        step: v.optional(v.number()),
        suffix: v.optional(v.string()),
      }),
      default_value: v.tuple([v.number(), v.number()]),
    }),
    v.object({
      component: v.literal("FilterSlider"),
      attrs: v.object({
        min: v.number(),
        max: v.number(),
        step: v.optional(v.number()),
        suffix: v.optional(v.string()),
      }),
      default_value: v.tuple([v.number()]),
    }),
  ]),
]);
export type ShopFilter = InferOutput<typeof shopFilterSchema>;

export const shopOptionsSchema = v.object({
  filters: v.record(v.string(), shopFilterSchema),
  facet_by: v.array(v.string()),
  query_by: v.array(v.string()),
});
export type ShopOptions = InferOutput<typeof shopOptionsSchema>;

export const shopFacetSchema = v.object({
  field_name: v.string(),
  counts: v.array(v.object({
    count: v.number(),
    value: v.string(),
  })),
});
export type ShopFacet = InferOutput<typeof shopFacetSchema>;

export const shopSchema = v.object({
  products: v.array(productDocumentSchema),
  products_total: v.number(),
  facets: v.array(shopFacetSchema),
});
export type Shop = InferOutput<typeof shopSchema>;
